import { render, staticRenderFns } from "./SquareMetersPriceArrayTrend.vue?vue&type=template&id=f866906e&"
import script from "./SquareMetersPriceArrayTrend.vue?vue&type=script&lang=js&"
export * from "./SquareMetersPriceArrayTrend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports